import { request } from '../request';
import apiRoute from './router';

/** 获取配置信息 */
export function getSysConfig() {
  return request.get<ApiAuth.Config>(apiRoute.commonConfig);
}

/** 登录 */
export function login(data: ApiAuth.LoginParams) {
  return request.post<ApiAuth.LoginResult>(apiRoute.adminLogin, data);
}
